<template>
    <div class="captcha-container" v-if="visible">
      <div class="captcha-wrapper">
        <!-- 背景图 -->
        <div class="captcha-image" :style="{ width: width + 'px', height: height + 'px' }">
          <img :src="backgroundUrl" alt="background" />
          <!-- 滑块缺口层 -->
          <div class="slider-gap" :style="gapStyle"></div>
        </div>
        
        <!-- 滑块轨道 -->
        <div class="slider-track" :style="{ width: width + 'px' }">
          <div 
            class="slider-button" 
            :style="{ left: sliderX + 'px' }" 
            @mousedown="handleMouseDown" 
            @touchstart="handleTouchStart"
          >
            <span>▶</span>
          </div>
          <div class="slider-progress" :style="{ width: sliderX + 'px' }"></div>
        </div>
        
        <!-- 提示信息 -->
        <div class="captcha-message" :class="messageType">{{ message }}</div>
        
        <!-- 隐藏字段 -->
        <input type="hidden" :value="captchaToken" />
      </div>
    </div>
  </template>
  
  <script>
  //import * as FingerprintJS from '@fingerprintjs/fingerprintjs';
  import { ip1 } from '@/assets/js/public.js'
  import axios from 'axios';
  export default {
    name: 'CaptchaSlider',
    
    props: {
      // 可以添加props，如宽度高度等
      width: {
        type: Number,
        default: 300
      },
      height: {
        type: Number,
        default: 150
      }
    },
    
    data() {
      return {
        visible: true,
        backgroundUrl: '',
        sliderUrl: '',
        gapStyle: {},
        sliderX: 0,
        isDragging: false,
        startX: 0,
        track: [],
        deviceId: '12587',
        captchaId: '',
        captchaToken: '',
        message: '请拖动滑块完成验证',
        messageType: 'info',
        
        // 用于存储事件监听器的引用，以便正确移除
        mouseMoveHandler: null,
        mouseUpHandler: null,
        touchMoveHandler: null,
        touchEndHandler: null
      };
    },
    
    mounted() {
      //this.initDeviceId();
      // 加载验证码
      this.loadCaptcha();
    },
    
    beforeDestroy() {
      // 组件销毁前移除事件监听器
      this.removeEventListeners();
    },
    
    methods: {
      // 初始化设备指纹
      // initDeviceId() {
      //   FingerprintJS.load()
      //   .then(fp => fp.get())
      //   .then(result => {
      //     this.deviceId = result.visitorId;
      //   });
      // },
      
      // 加载验证码
      async loadCaptcha() {
        try {
            axios.get(`${ip1}api/Account/GenerateCaptcha?deviceId=${this.deviceId}`,null).then(res =>{
            if (res.data.code === 20000) {
                console.log(res.data.data)
                const data = res.data.data;
                this.captchaId = data.captchaId;
                this.backgroundUrl = `data:image/png;base64,${data.backgroundImage}`;
                this.sliderUrl = `data:image/png;base64,${data.sliderImage}`;
                
                // 缺口位置（仅用于前端展示，真实位置后端校验）
                this.gapStyle = {
                left: '0px',
                top: data.gapY + 'px',
                backgroundImage: `url(${this.sliderUrl})`,
                backgroundSize: `${this.width}px ${this.height}px`,
                backgroundPosition: `-${data.gapX}px -${data.gapY}px`
                };
            } else {
                this.message = '滑块验证加载失败';
                this.messageType = 'error';
            }
        })
        } catch (error) {
          console.error('加载验证码失败:', error);
          this.message = '加载失败，请重试';
          this.messageType = 'error';
        }
      },
      
      // 鼠标/触摸事件
      handleMouseDown(e) {
        this.startDrag(e.clientX);
      },
      
      handleTouchStart(e) {
        if (e.touches.length > 0) {
          this.startDrag(e.touches[0].clientX);
        }
      },
      
      startDrag(x) {
        this.isDragging = true;
        this.startX = x - this.sliderX;
        this.track = [];
        
        // 绑定事件监听器
        this.mouseMoveHandler = this.handleMouseMove.bind(this);
        this.mouseUpHandler = this.handleMouseUp.bind(this);
        this.touchMoveHandler = this.handleTouchMove.bind(this);
        this.touchEndHandler = this.handleTouchEnd.bind(this);
        
        document.addEventListener('mousemove', this.mouseMoveHandler);
        document.addEventListener('mouseup', this.mouseUpHandler);
        document.addEventListener('touchmove', this.touchMoveHandler, { passive: false });
        document.addEventListener('touchend', this.touchEndHandler);
        
        // 防止默认行为
        if (event.cancelable) {
          event.preventDefault();
        }
      },
      
      handleMouseMove(e) {
        if (!this.isDragging) return;
        this.moveSlider(e.clientX);
      },
      
      handleTouchMove(e) {
        if (!this.isDragging) return;
        if (e.touches.length > 0) {
          this.moveSlider(e.touches[0].clientX);
        }
        // 防止页面滚动
        if (e.cancelable) {
          e.preventDefault();
        }
      },
      
      moveSlider(x) {
        const newX = Math.max(0, Math.min(x - this.startX, this.width - 40));
        this.sliderX = newX;
        
        // 记录轨迹
        this.track.push({
          x: newX,
          y: 0, // Y轴不变
          t: Date.now()
        });
        
        // 更新缺口位置
        this.gapStyle.left = newX + 'px';
      },
      
      handleMouseUp() {
        this.endDrag();
      },
      
      handleTouchEnd() {
        this.endDrag();
      },
      
      async endDrag() {
        if (!this.isDragging) return;
        this.isDragging = false;
        
        this.removeEventListeners();
        
        // 验证
        await this.verifyCaptcha();
      },
      
      // 移除事件监听器
      removeEventListeners() {
        if (this.mouseMoveHandler) {
          document.removeEventListener('mousemove', this.mouseMoveHandler);
        }
        if (this.mouseUpHandler) {
          document.removeEventListener('mouseup', this.mouseUpHandler);
        }
        if (this.touchMoveHandler) {
          document.removeEventListener('touchmove', this.touchMoveHandler);
        }
        if (this.touchEndHandler) {
          document.removeEventListener('touchend', this.touchEndHandler);
        }
      },
      
      // 验证滑块
      async verifyCaptcha() {
        try {
            // 这里需要根据实际的API调整
            let params={
            captchaId: this.captchaId,
            sliderPosition: this.sliderX,
            track: this.track,
            deviceId: this.deviceId,
            timestamp: Date.now()
            };
            axios.post(`${ip1}api/Account/VerifyCaptch`,params).then(res =>{
                console.log(res);
                if (res.data.code === 20000) {
                    this.message = '验证成功';
                    this.messageType = 'success';
                    this.visible = false;  
                    // 触发成功事件
                    this.$emit('success', { st: res.data.data.st});
                } else {
                    this.message = res.message || '验证失败，请重试';
                    this.messageType = 'error';
                    this.resetSlider();
                }
            })
        }
        catch (error) {
          console.error('验证失败:', error);
          this.message = '验证失败，请重试';
          this.messageType = 'error';
          this.resetSlider();
        }
      },
      
      // 重置滑块
      resetSlider() {
        setTimeout(() => {
          this.sliderX = 0;
          this.track = [];
          this.message = '请拖动滑块完成验证';
          this.messageType = 'info';
          this.loadCaptcha();
        }, 1000);
      },
      
      // 对外提供重置方法
      reset() {
        this.sliderX = 0;
        this.track = [];
        this.message = '请拖动滑块完成验证';
        this.messageType = 'info';
        this.visible = true;
        this.loadCaptcha();
      },
      
      // 对外提供显示/隐藏方法
      show() {
        this.visible = true;
        this.reset();
      },
      
      hide() {
        this.visible = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .captcha-container {
    position: relative;
    z-index: 1000;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    min-width: 340px;
  }
  
  .captcha-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .captcha-image {
    position: relative;
    margin-bottom: 10px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
  }
  
  .captcha-image img {
    width: 100%;
    height: 100%;
    display: block;
    user-select: none;
    -webkit-user-drag: none;
  }
  
  .slider-gap {
    position: absolute;
    width: 40px;
    height: 40px;
    border: 1px solid #fff;
    border-radius: 2px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.3);
    pointer-events: none;
    transition: left 0.1s;
  }
  
  .slider-track {
    position: relative;
    height: 40px;
    background: #f0f0f0;
    border-radius: 20px;
    border: 1px solid #e0e0e0;
    margin-top: 10px;
    user-select: none;
  }
  
  .slider-button {
    position: absolute;
    width: 40px;
    height: 40px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 10;
    transition: background-color 0.2s, box-shadow 0.2s;
    user-select: none;
  }
  
  .slider-button:hover {
    background: #f5f5f5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  }
  
  .slider-button:active {
    cursor: grabbing;
    background: #f0f0f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }
  
  .slider-button span {
    font-size: 14px;
    color: #666;
  }
  
  .slider-progress {
    position: absolute;
    height: 100%;
    background: linear-gradient(90deg, #91d5ff, #1890ff);
    border-radius: 20px;
    opacity: 0.8;
    transition: width 0.1s;
  }
  
  .captcha-message {
    margin-top: 12px;
    text-align: center;
    font-size: 14px;
    min-height: 20px;
    font-weight: 500;
  }
  
  .message-info { 
    color: #1890ff; 
  }
  
  .message-success { 
    color: #52c41a; 
  }
  
  .message-error { 
    color: #ff4d4f; 
  }
  
  /* 移动端优化 */
  @media (max-width: 768px) {
    .captcha-container {
      padding: 15px;
      min-width: 300px;
    }
    
    .captcha-image {
      width: 280px !important;
      height: 140px !important;
    }
    
    .slider-track {
      width: 280px !important;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/land/sliderCaptcha.vue